import Types from '../Types';
import Immutable from 'seamless-immutable';
import { createReducer } from 'reduxsauce';
import _merge from 'lodash.merge'

export const INITIAL_STATE = Immutable({
  error: null,
  findAttempting: false, findAllAttempting: false, pageCount: 0, payments: [],
  notifying: false, notified: false
});

const ACTION_HANDLERS = {
  [Types.FIND_PAYMENTS_ATTEMPT]: (state, action) =>
    state.merge({ findAttempting: true }),
  [Types.FIND_PAYMENTS_SUCCESS]: (state, action) =>
    state.merge({
      findAttempting: false,
      payments: action.result,
      error: null
    }),
  [Types.FIND_PAYMENTS_FAILURE]: (state, action) =>
    state.merge({ findAttempting: false, error: action.error }),

  [Types.FIND_ALL_PAYMENTS_ATTEMPT]: (state, action) =>
    state.merge({ findAllAttempting: true }),
  [Types.FIND_ALL_PAYMENTS_SUCCESS]: (state, action) =>
    state.merge({
      findAllAttempting: false,
      pageCount: action.result.pageCount,
      payments: action.result.payments,
      error: null
    }),
  [Types.FIND_ALL_PAYMENTS_FAILURE]: (state, action) =>
    state.merge({ findAllAttempting: false, error: action.error }),

  [Types.SAVE_ORDER_SUCCESS]: (state, action) =>
    state.merge({
      payments: state.payments.map(payment =>
        payment.orderId === action.result.orderId ? payment.merge({ orderStatus: action.result.paidStatus }) : payment
      ),
      error: null
    }),

  [Types.NOTIFY_PAYMENT_ATTEMPT]: (state, action) =>
    state.merge({ notifying: true, notified: false }),
  [Types.NOTIFY_PAYMENT_SUCCESS]: (state, action) =>
    state.merge({ notifying: false, notified: true }),
  [Types.NOTIFY_PAYMENT_FAILURE]: (state, action) =>
    state.merge({ notifying: false, notified: false, error: action.error }),

};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



/** WEBPACK FOOTER **
 ** ./src/redux/payment/paymentReducer.js
 **/